import axios from 'axios';
import { api } from '../utils/helper';

//****************** GET getDivisionMDSR By org,proj ******************//
export const getDivisionMDSR = async (a) => {
    try {

        const resrep = await axios.post(
            `${api}/getdivisionmdsr`, a,
            {
                headers: {
                    authorization: sessionStorage.getItem('token'),
                },
            },
        );

//        console.log(`getDivisionMDSR controller res: `, resrep);
        return resrep;
    } catch (error) {
//        console.log(`getDivisionMDSR controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}

//****************** GET getTownshipMDSR By org,proj ******************//
export const getTownshipMDSR = async (a) => {
    try {

        const resrep = await axios.post(
            `${api}/gettownshipmdsr`, a,
            {
                headers: {
                    authorization: sessionStorage.getItem('token'),
                },
            },
        );

//        console.log(`getTownshipMDSR controller res: `, resrep);
        return resrep;
    } catch (error) {
//        console.log(`getTownshipMDSR controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}

//****************** getTownshipMDSROther ******************//
export const getTownshipMDSROther = async () => {
  try {
    const resrep = await axios.get(`${api}/gettownshipmdsrother`, {
      headers: {
        authorization: sessionStorage.getItem('token'),
      },
    });
//    console.log('getTownshipMDSROther controller res: ', resrep);
    return resrep;
  } catch (error) {
//    console.log('getTownshipMDSROther controller error: ', error?.response?.data);
    alert(error?.response?.data?.message);
  }

}

//****************** getVillageMDSR ******************//
export const getVillageMDSR = async (a) => {
  try {
    const resrep = await axios.post(`${api}/getvillagemdsr`, a, {
      headers: {
        authorization: sessionStorage.getItem('token'),
      },
    });
//    console.log('getVillageMDSR controller res: ', resrep);
    return resrep;
  } catch (error) {
//    console.log('getVillageMDSR controller error: ', error?.response?.data);
    alert(error?.response?.data?.message);
  }
}

//****************** getClinicMDSR ******************//
export const getClinicMDSR = async (a) => {
  try {
    const resrep = await axios.post(`${api}/getclinicmdsr`, a, {
      headers: {
        authorization: sessionStorage.getItem('token'),
      },
    });
//    console.log('getClinicMDSR controller res: ', resrep);
    return resrep;
  } catch (error) {
//    console.log('getClinicMDSR controller error: ', error?.response?.data);
    alert(error?.response?.data?.message);
  }
}

//****************** getProjectNameMDSR ******************//
export const getProjectNameMDSR = async (a) => {
  try {
    const resrep = await axios.post(`${api}/getprojectnamemdsr`, a, {
      headers: {
        authorization: sessionStorage.getItem('token'),
      },
    });
//    console.log('getProjectNameMDSR controller res: ', resrep);
    return resrep;
  } catch (error) {
//    console.log('getProjectNameMDSR controller error: ', error?.response?.data);
    alert(error?.response?.data?.message);
  }
}

